interface IconProps {
  color?: string
}

export const Upload = ({ color }: IconProps) => {
  return (
    <svg
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      width="20px"
      height="20px"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M10 14V4.75M6.75 8L10 4.75L13.25 8"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.75 12.75V13.75C4.75 14.7165 5.5335 15.5 6.5 15.5H13.5C14.4665 15.5 15.25 14.7165 15.25 13.75V12.75"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
